export default "__VITE_ASSET__BRvJazEy__"